/**
 * "Counting 7 of 9 reasons": every box in the "What counts as an absence?" checklist is one item — PTO, replace
 * requests, and each call-off reason — so the tooltip and the panel's footer count the same thing (DAT-850).
 */
export function countedAbsenceItems({
	countsPto,
	countsReplaceRequests,
	reasonDecisions,
}: {
	countsPto: boolean;
	countsReplaceRequests: boolean;
	reasonDecisions: boolean[];
}): { counted: number; total: number } {
	const items = [countsPto, countsReplaceRequests, ...reasonDecisions];
	return { counted: items.filter(Boolean).length, total: items.length };
}
